/**
 * Дизайн-токены внутреннего портала (кабинеты admin/operator/manager).
 *
 * Единый источник палитры для редизайна внутренней части: сюда смотрят и тема
 * Mantine (`main.tsx`), и каркас (`InternalShell`), и экраны. Клиентская часть
 * живёт на своей палитре (TEAL #0FAC97 в `pages/client/**`) — она уже
 * отредизайнена и здесь НЕ участвует.
 *
 * Значения согласованы с мокапом internal-home-web.png (07.08.2026).
 */

/** Акцент — бирюзовый. Активные пункты, ссылки, фокус. */
export const ACCENT = '#09AF9A';
export const ACCENT_DARK = '#078C7B';
/** Подложка акцента: активный пункт меню, иконки в плитках. */
export const ACCENT_SOFT = '#E6F7F4';

/** Основной текст — глубокий navy. */
export const TEXT = '#12213D';
/** Вторичный текст, подписи, описания разделов. */
export const MUTED = '#6B7A90';
/** Приглушённый текст на тёмном сайдбаре. */
export const SIDEBAR_MUTED = '#8FA5AD';
/**
 * Заголовки групп в сайдбаре («Работа», «Администрирование»).
 *
 * Оранжевый, а не SIDEBAR_MUTED: подписи групп кликабельными НЕ являются, но в
 * общем приглушённом цвете читались как обычные пункты меню (фидбек Artem
 * 08.08.2026). Взят оттенок светлее WARN (#F08C00): на фоне SIDEBAR_BG тот даёт
 * 6.85:1, этот — 8.94:1. Оба проходят AA, но текст здесь мелкий (11.5px) и
 * разрежённый, так что запас по контрасту не лишний.
 */
export const SIDEBAR_GROUP = '#FFA94D';

/** Тёмная навигационная панель. */
export const SIDEBAR_BG = '#071F27';
/** Ховер пункта в сайдбаре. */
export const SIDEBAR_HOVER = '#0A2630';
/**
 * Подложка активного пункта меню. Заметно светлее ховера: с 07.08.2026 это
 * ЕДИНСТВЕННЫЙ признак выбранного раздела (полоска-акцент слева убрана),
 * поэтому от ховера она обязана отличаться однозначно.
 */
export const ACTIVE_BG = '#12414A';

/** Холодный фон приложения. */
export const APP_BG = '#F4F7F9';
/** Поверхность карточек и панелей. */
export const SURFACE = '#FFFFFF';
/** Тонкая граница карточек и разделителей. */
export const BORDER = '#E3E9EF';

/** Статусные цвета — для счётчиков и предупреждений. */
export const WARN = '#F08C00';
export const DANGER = '#E03131';

/** Радиусы карточек по мокапу. */
export const RADIUS_CARD = 16;
export const RADIUS_CONTROL = 10;

/** Очень мягкая тень карточек — без «бутстраповской» тяжести. */
export const SHADOW_CARD = '0 1px 3px rgb(18 33 61 / 6%)';
export const SHADOW_CARD_HOVER = '0 4px 16px rgb(18 33 61 / 10%)';

/** Ширина сайдбара на desktop. 264 → 224 (−15%) по фидбеку Artem 07.08.2026:
 *  вместе с уплотнением пунктов все 23 раздела влезают без прокрутки. */
export const SIDEBAR_WIDTH = 224;
/** Высота верхней панели. */
export const TOPBAR_HEIGHT = 64;
/** Максимальная ширина контента рабочей области. */
export const CONTENT_MAX_WIDTH = 1280;

/**
 * Брейкпоинт «есть ли место под постоянный сайдбар».
 * Ниже — сайдбар уезжает в Drawer (тот же паттерн, что в ClientShell).
 */
export const DESKTOP_QUERY = '(min-width: 64em)';
